export const getShortRoleByUser = (roles: string[]) => {
    if (roles.includes('mnemo_creative')) {
        return 'MC';
    } else if (roles.includes('editor')) {
        return 'ME';
    } else {
        return 'LP';
    }
};
